export const    CLEAN_RESIDENT = 'CLEAN_RESIDENT';
export const    CLEAN_RESIDENT_SUCCESS = 'CLEAN_RESIDENT_SUCCESS';
export const    CLEAN_RESIDENT_ERROR = 'CLEAN_RESIDENT_ERROR';

export const    RESIDENT = 'RESIDENT';
export const    RESIDENT_SUCCESS = 'RESIDENT_SUCCESS';
export const    RESIDENT_ERROR = 'RESIDENT_ERROR';

export const    ADD_RESIDENT = 'ADD_RESIDENT';
export const    ADD_RESIDENT_SUCCESS = 'ADD_RESIDENT_SUCCESS';
export const    ADD_RESIDENT_ERROR = 'ADD_RESIDENT_ERROR';

export const    UPDATE_RESIDENT = 'UPDATE_RESIDENT';
export const    UPDATE_RESIDENT_SUCCESS = 'UPDATE_RESIDENT_SUCCESS';
export const    UPDATE_RESIDENT_ERROR = 'UPDATE_RESIDENT_ERROR';

export const DELETE_RESIDENT = 'DELETE_RESIDENT';
export const DELETE_RESIDENT_SUCCESS= 'DELETE_RESIDENT_SUCCESS';
export const DELETE_RESIDENT_ERROR ='DELETE_RESIDENT_ERROR';

export const GET_TAGS_RESIDENT = 'GET_TAGS_RESIDENT';
export const GET_TAGS_RESIDENT_SUCCESS= 'GET_TAGS_RESIDENT_SUCCESS';
export const GET_TAGS_RESIDENT_ERROR ='GET_TAGS_RESIDENT_ERROR';

export const RESIDENT_BY_TAGS = 'RESIDENT_BY_TAGS';
export const RESIDENT_BY_TAGS_SUCCESS= 'RESIDENT_BY_TAGS_SUCCESS';
export const RESIDENT_BY_TAGS_ERROR ='RESIDENT_BY_TAGS_ERROR';

export const SYNC_RESIDENTS = 'SYNC_RESIDENTS';
export const SYNC_RESIDENTS_SUCCESS= 'SYNC_RESIDENTS_SUCCESS';
export const SYNC_RESIDENTS_ERROR ='SYNC_RESIDENTS_ERROR';

export const SYNC_RESIDENTS_BY_COMMUNITY = 'SYNC_RESIDENTS_BY_COMMUNITY';
export const SYNC_RESIDENTS_BY_COMMUNITY_SUCCESS= 'SYNC_RESIDENTS_BY_COMMUNITY_SUCCESS';
export const SYNC_RESIDENTS_BY_COMMUNITY_ERROR ='SYNC_RESIDENTS_BY_COMMUNITY_ERROR';